module.exports = __webpack_public_path__ + "img/commentTask_example.0f8f4c87.png";